import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";

const AddMasterNumberDIOD = () => {
  const { auth } = useAuth();
  const [file, setFile] = useState("");
  const [fileError, setFileError] = useState("");
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (auth.role !== "1") {
      window.location.href = "/";
    }
  }, []);

  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "csv") {
      setFileError("Please upload csv format file");
      setFile("Invalid File");
    } else {
      setFileError("");
      setFile(file);
    }
  };
  const createmasterNo = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);

    var formData = new FormData();
    formData.append("userfile", file);
    if (fileError === "" && file !== "") {
      axios
        .post(url + "store-diod", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code !== 400) {
              if (response.data.message === "Data added") {
                setLoader(false);
                toast.success("Master no added successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/master-number";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/master-number">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>ADD MASTER NUMBER</h3>
                <p>
                  Please enter the details for the new company, add user
                  information, select a master number and package.
                </p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form onSubmit={createmasterNo}>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">
                    Master number information
                  </legend>
                </div>
                {/* <div className="uk-width-1-2@m uk-margin-top">
                  <label>Master number</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Master number DIOD"
                    aria-label="Input"
                  />
                </div> */}

                <div className="uk-width-1-1@m uk-margin-top">
                  <label>
                    <b>Upload a file</b>
                  </label>
                  <span className="fileDisc">import DIOD from a CSV file</span>
                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                      {errorEnable && file === "" && (
                        <div className="formErrors">Please upload file</div>
                      )}
                      {errorEnable && fileError !== "" && (
                        <div className="formErrors">{fileError}</div>
                      )}
                    </div>
                    {/* <button className="uk-button fileUploadBtn uk-button-default">Submit</button> */}
                  </div>
                  <a
                    href={
                      "https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/MasterNumbers.csv"
                    }
                    className="DownloadFileBtn"
                  >
                    Download sample file
                  </a>
                </div>

                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    <Link to="/master-number" className="whiteBtn">
                      Cancel
                    </Link>
                    <button className="pinkBtn" type="submit">
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Add master number"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMasterNumberDIOD;
